import React, { ReactNode } from 'react'
import tw from 'twin.macro'
import styled from 'styled-components'
import { SlDetails } from '@shoelace-style/shoelace/dist/react'
import { useMatchBreakpoints } from '@nominex/dex-uikit'

const StyledSlDetails = styled(SlDetails)<{ isMobile: boolean }>`
  ${tw`w-full md:w-auto`}

  &::part(header) {
    ${tw`text-14 text-white font-semibold p-0 md:pointer-events-none`}
    ${({ isMobile }) => !isMobile && tw`md:pointer-events-none`};
  }

  &::part(base) {
    ${tw`bg-transparent border-none`}
  }

  &::part(content) {
    ${tw`pt-8 px-0 pb-0`}
  }

  &::part(summary-icon) {
    ${tw`md:hidden`}
  }
`

const FooterMenu: React.FC<{ title?: string; children: ReactNode }> = ({ children, title }) => {
  const { isMobile } = useMatchBreakpoints()

  return isMobile ? (
    <StyledSlDetails summary={title} isMobile={isMobile}>
      {children}
    </StyledSlDetails>
  ) : (
    <StyledSlDetails summary={title} isMobile={isMobile} open>
      {children}
    </StyledSlDetails>
  )
}

export default FooterMenu
